import { render, staticRenderFns } from "./DashboardEmptyContainer.vue?vue&type=template&id=7cecec35&scoped=true"
import script from "./DashboardEmptyContainer.vue?vue&type=script&lang=js"
export * from "./DashboardEmptyContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cecec35",
  null
  
)

export default component.exports